'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$0024101 from "./presto.types$$anon$101.js";
import * as $j_presto$002etypes$0024$0024anon$002495 from "./presto.types$$anon$95.js";
import * as $j_presto$002etypes$0024$002dRule$002dKind$0024 from "./presto.types$-Rule-Kind$.js";
import * as $j_presto$002etypes$0024$002dTime$002dPayload$0024 from "./presto.types$-Time-Payload$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Rule$$anon$94(outer) {
  this.car = null;
  this.caj = null;
  this.cak = false;
  this.cas = null;
  this.cat = false;
  this.caw = null;
  this.cap = null;
  this.caq = false;
  this.cal = null;
  this.cam = false;
  this.can = null;
  this.cao = false;
  this.cau = false;
  this.cav = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.car = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.caw = "TimePayload";
}
export { $c_Lpresto_types$Rule$$anon$94 as $c_Lpresto_types$Rule$$anon$94 };
$p = $c_Lpresto_types$Rule$$anon$94.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Rule$$anon$94;
/** @constructor */
function $h_Lpresto_types$Rule$$anon$94() {
}
export { $h_Lpresto_types$Rule$$anon$94 as $h_Lpresto_types$Rule$$anon$94 };
$h_Lpresto_types$Rule$$anon$94.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.car;
});
$p.L = (function() {
  if ((!this.cak)) {
    this.caj = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.cak = true;
  }
  return this.caj;
});
$p.O = (function() {
  if ((!this.cat)) {
    this.cas = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.cat = true;
  }
  return this.cas;
});
$p.E = (function() {
  return this.caw;
});
$p.t = (function() {
  if ((!this.caq)) {
    this.cap = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("ranges", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.caq = true;
  }
  return this.cap;
});
$p.M = (function() {
  if ((!this.cam)) {
    this.cal = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRule$002dKind$0024.$m_Lpresto_types$RuleKind$().SM(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002etypes$0024$0024anon$002495.$c_Lpresto_types$$anon$95())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.cam = true;
  }
  return this.cal;
});
$p.Q = (function() {
  if ((!this.cao)) {
    this.can = new $j_presto$002etypes$0024$0024anon$0024101.$c_Lpresto_types$$anon$101();
    this.cao = true;
  }
  return this.can;
});
$p.w = (function() {
  if ((!this.cav)) {
    this.cau = false;
    this.cav = true;
  }
  return this.cau;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee148) => ((p) => \u03b4scrutinee148.cGx(p)))($j_presto$002etypes$0024$002dTime$002dPayload$0024.$m_Lpresto_types$TimePayload$())));
});
var $d_Lpresto_types$Rule$$anon$94 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Rule$$anon$94, "presto.types$Rule$$anon$94", ({
  a1d: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_types$Rule$$anon$94 as $d_Lpresto_types$Rule$$anon$94 };
//# sourceMappingURL=presto.types$-Rule$$anon$94.js.map
